/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import ReusableList from '../../../common/ReusableListView';
import TaskBox from './AssignmentsDetailsComponent';
import { useSideBySideViewStyles } from './styles/AssignmentSectionStyles';


const SideBySideView = ({
  completedItems,
  upNextItems,
  selectedItem,
  onSelect,
  renderRightContent
}) => {
  const classes = useSideBySideViewStyles();

  return (
    <Box className={classes.rowContainer}>
      <Box className={classes.left}>
        <ReusableList
          data={completedItems}
          selectedItem={selectedItem}
          onSelect={onSelect}
        >
          {item => (
            <TaskBox
              title={item.title}
              dueText={item.dueText}
              percentComplete={item.percentComplete}
              assignmentComplete={item.assignmentComplete}
              chapters={item.chapters}
              isSelected={item.id === selectedItem}
            />
          )}
        </ReusableList>

        {upNextItems.length > 0 && (
          <>
            <Box className={classes.upNextSection} onClick={() => { }}>
              <Typography className={classes.upNextText}>Up next</Typography>
              <IconButton
                size="small"
                className={classes.upNextIcon}
                aria-label="add next item"
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
            <ReusableList
              data={upNextItems}
              selectedItem={selectedItem}
              onSelect={onSelect}
            >
              {item => (
                <TaskBox
                  title={item.title}
                  dueText={item.dueText}
                  percentComplete={item.percentComplete}
                  assignmentComplete={item.assignmentComplete}
                  chapters={item.chapters}
                  isSelected={item.id === selectedItem}
                />
              )}
            </ReusableList>
          </>
        )}
      </Box>

      <Box className={classes.right}>
        {selectedItem && renderRightContent(selectedItem)}
      </Box>
    </Box>
  );
};

SideBySideView.propTypes = {
  completedItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  upNextItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItem: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  renderRightContent: PropTypes.func.isRequired
};

export default SideBySideView;
